<template>
  <Dropdown v-bind="$attrs" v-on="$listeners">
    <slot />
    <Menu slot="overlay" :class="extraclass">
      <MenuItem
        v-for="(item, index) in items"
        :key="index"
        @click="handleButtonClick(item)"
      >
        {{ item }}
      </MenuItem>
    </Menu>
  </Dropdown>
</template>

<script>
import { Dropdown, Menu } from "ant-design-vue";

export default {
  components: {
    Dropdown,
    Menu,
    MenuItem: Menu.Item
  },
  methods: {
    handleButtonClick(value) {
      this.$emit("on-return-value", value);
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    extraclass: {
      type: String,
      default: ""
    }
  }
};
</script>
